import { useRef } from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { Link, useLocation } from 'react-router-dom'
import Navbar from '../Component/Navbar'
import Footer from '../Component/Footer'
// ASSESTS
import Football from '../assets/football.png'
import netImg from '../assets/goal net.png'
import journeyArrow from '../assets/Arrow 9 3.png'
import grCard from '../assets/GR-card.png'
import trophyIcon from '../assets/Trophy Win Star.png'
import filledLineup from '../assets/filled lineup.png'
import seierLogo from '../assets/seier logo.png'
import concordiumLogo from '../assets/networks-assets/Concordium Symbol_White.svg'
import XvcLogo from '../assets/XVC tech-logo-light.png'
import XdcLogo from '../assets/XDC logo.jpg'
import FoundershipLogo from '../assets/Foundership Logo.png'
import StarknetLogo from '../assets/starknet-logo.png'
import {
  useBouncingEffect,
  useFootballRotation,
  useHomePageAnimation,
} from './HomeAnimations'
import React from 'react'

export default function Home() {
  // animation =====================
  const main = useRef()
  useBouncingEffect(main)
  useHomePageAnimation(main)
  useFootballRotation(main)

  const location = useLocation()

  const articles = [
    {
      title:
        'Panenka FC Exceeds 100k Users: The Rise of Trust in Fantasy Football Startups',
      url: 'https://www.concordium.com/article/panenka-fc-exceeds-100k-users-the-rise-of-trust-in-fantasy-football',
      imgLink:
        'https://cdn.prod.website-files.com/67d7fbcd510cf4a3a626797d/6866676d004ae1485b1ca27c_Panenka%20FC%20100%2C000%20Users.jpg',
      publisher: 'Concordium',
      date: 'July 3, 2025',
    },
    {
      title:
        'XinFin XDC Network and Foundership Inaugurate XDC 0xCamp Accelerator Program to Propel Global Web3 Startups',
      url: 'https://cryptoslate.com/press-releases/xinfin-xdc-network-and-foundership-inaugurate-xdc-0xcamp-accelerator-program-to-propel-global-web3-startups/',
      imgLink:
        'https://cryptoslate.com/wp-content/themes/cryptoslate-2020/imgresize/timthumb.php?src=https://cryptoslate.com/wp-content/uploads/2024/09/xinfin-pr.jpg&w=1050&h=551&q=75',
      publisher: 'Chainwire',
      date: 'Sep. 2, 2024',
    },
    {
      title:
        'Concordium Backs Panenka FC To Transform Fantasy Football Landscape',
      url: 'https://medium.com/@joepaul657/concordium-backs-panenka-fc-to-transform-fantasy-football-landscape-9e83ca40f450',
      imgLink:
        'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*WL_OA31ptG6jdWQGgenqsg@2x.jpeg',
      publisher: 'Joe Paul',
      date: 'Jul 30, 2024',
    },
    {
      title:
        'Mastering Panenka FC: Your Guide to Winning Fantasy Football with Smart Strategies',
      url: 'https://panenkafc.medium.com/mastering-panenka-fc-your-guide-to-winning-fantasy-football-with-smart-strategies-c82ac45983ed',
      imgLink:
        'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*TFQG_ctLdDHxfJHEKSTC5A.jpeg',
      publisher: 'Panenka FC',
      date: 'Oct 12 2024',
    },
    {
      title:
        'Panenka FC and Concordium: Innovating Fantasy Football with Transparency and Security',
      url: 'https://medium.com/@concordium/panenka-fc-and-concordium-innovating-fantasy-football-with-transparency-and-security-83f7fd677a17',
      imgLink:
        'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*noyD83lhc11EB5el94Yjlg.png',
      publisher: 'Concordium',
      date: 'Apr 24, 2024',
    },
    {
      title:
        'Panenka FC: Elevating Fantasy Football to New Heights with Immersive and Fair Play',
      url: 'https://panenkafc.medium.com/panenka-fc-elevating-fantasy-football-to-new-heights-with-immersive-and-fair-play-96a95502981e',
      imgLink:
        'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*FBHSgC9U3iwBJ8YzDNrJ2w.jpeg',
      publisher: 'Panenka FC',
      date: 'Aug 21, 2024',
    },
    {
      title:
        "Fantasy Football 101: A Beginner's Guide to Dominating Your League",
      url: 'https://panenkafc.medium.com/fantasy-football-101-a-beginners-guide-to-dominating-your-league-dbc93e1b0dd3',
      imgLink:
        'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*E-kjA9ENnaZZUDdESaxfHg.jpeg',
      publisher: 'Panenka FC',
      date: 'Oct 2, 2024',
    },
    {
      title:
        'Tackling Rigged Fantasy Football Platforms: What Could Be a Possible Solution?',
      url: 'https://panenkafc.medium.com/tackling-rigged-fantasy-football-platforms-what-could-be-a-possible-solution-6461fb05ab67',
      imgLink:
        'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*E_XoDMKkC8hBLtiZpia0qQ.jpeg',
      publisher: 'Panenka FC',
      date: 'Sep 6, 2024',
    },
    {
      title:
        'What Fuels the Fantasy Football Frenzy? Discover the Key Drivers Behind Its Popularity',
      url: 'https://panenkafc.medium.com/what-fuels-the-fantasy-football-frenzy-discover-the-key-drivers-behind-its-popularity-d5802eabf91b',
      imgLink:
        'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*pSQBspG04uOiKlqOIElafg.jpeg',
      publisher: 'Panenka FC',
      date: 'Aug 6, 2024',
    },
    {
      title:
        'XDC Network and Foundership Unite to Empower Web3 Startups at Demo Day',
      url: 'https://www.cryptotimes.io/2024/10/01/xdc-network-and-foundership-unite-to-empower-web3-startups-at-demo-day/',
      imgLink:
        'https://www.cryptotimes.io/wp-content/uploads/2024/10/XDC-Network-and-Foundership-Unite-to-Empower-Web3-Startups-at-Demo-Day-860x496.png',
      publisher: 'Crypto Times',
      date: 'October 1, 2024',
    },
  ]

  const responsiveOption = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024,
      },
      items: 3,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: {
        max: 600,
        min: 0,
      },
      items: 1,
      partialVisibilityGutter: 0,
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 600,
      },
      items: 2,
      partialVisibilityGutter: 0,
    },
  }

  return (
    <>
      <main id='landingPage' ref={main}>
        {/* navbar */}
        <Navbar />
        {/* <Ticker /> */}

        <section className='hero-section'>
          <div className='half-area' style={{ zIndex: '5' }}>
            <h1 className='hero-heading '>
              Welcome to the <br />
              <span className='greenGradientTxt'>Fan Club</span>
            </h1>
            <p className='para'>
              The most immersive, fun and fair fantasy football experience
            </p>
          </div>
          {/* net image */}
          <img src={netImg} alt='' className='netImg' />
        </section>
        <div className='football-container'>
          <div>
            <img
              id='football'
              className='football '
              src={Football}
              alt='football'
            />
            <h2>The next generation of </h2>
            <h1 className='greenGradientTxt' style={{ marginBottom: '50px' }}>
              fantasy gaming
            </h1>
          </div>
        </div>
        {/* saved section  */}

        {/* journey ======================================================================== */}
        <section className='journey '>
          <h1 className='section-title blueGradientTxt animateJourneyText '>
            Your Journey
          </h1>

          <div
            className='row animateJourneyText'
            style={{ justifyContent: 'center' }}
          >
            <img src={journeyArrow} alt='' height={'50px'} />
          </div>

          <div className='journey-container right-img-container'>
            <div className='journey-content right-aligns'>
              <p className='animateJourneyText'>Step 1</p>
              <h2 className='animateJourneyText'>
                Join <span className='blueGradientTxt'>Game Rooms</span>
              </h2>
              <p className='animateJourneyText'>
                Join from hundreds of game rooms with different rules and prize
                pools, or create your own private game-room.
              </p>
            </div>
            <div className='journey-content animateJourneyImg'>
              <img src={grCard} alt='' srcSet='' />
            </div>
          </div>

          <div
            className='row animateJourneyImg'
            style={{ justifyContent: 'center' }}
          >
            <img src={journeyArrow} alt='' height={'50px'} />
          </div>

          <div className='journey-container left-img-container'>
            <div className='journey-content left-aligns'>
              <p className='animateJourneyText'>Step 2</p>
              <h2 className='animateJourneyText'>
                Create Your <span className='blueGradientTxt'>Lineup</span>
              </h2>
              <p className='animateJourneyText'>
                Create your dream starting 11 and use power ups to boost your
                points.
              </p>
            </div>
            <div className='journey-content  animateJourneyImg'>
              <img src={filledLineup} alt='' srcSet='' />
            </div>
          </div>

          <div
            className='row animateJourneyText'
            style={{ justifyContent: 'center' }}
          >
            <img src={journeyArrow} alt='' height={'50px'} />
          </div>

          <div className='journey-container right-img-container'>
            <div className='journey-content right-aligns'>
              <p className='animateJourneyText'>Step 3</p>
              <h2 className='animateJourneyText'>
                <span className='blueGradientTxt'>Win</span> &
                <span className='blueGradientTxt'> Cash</span> Out
              </h2>
              <p className='animateJourneyText'>
                Accumulate maximum points and win from the prize pool. Rewards
                are available to withdraw immediately.
              </p>
            </div>
            <div className='journey-content animateJourneyText'>
              <img
                src={trophyIcon}
                alt=''
                style={{ width: '30vw', maxWidth: '300px' }}
              />
            </div>
          </div>
        </section>

        {/* Why Panenka FC? ====================================*/}
        <section className='whySection'>
          <h1 className='section-title greenGradientTxt'>Why Panenka FC?</h1>
          <div className='row'>
            <div className='col-6 oneAnim'>
              <i className='bi bi-shield-check'></i>
              <h3 className='greenGradientTxt'>Fair & transparent</h3>
              <p>Smart contracts automate game management & payouts.</p>
            </div>
            <div className='col-6 twoAnim'>
              <i className='bi bi-person-check'></i>
              <h3 className='greenGradientTxt'>No more cheating</h3>
              <p>Verified user IDs using zero-knowledge proofs.</p>
            </div>
            <div className='col-6 threeAnim'>
              <i className='bi bi-joystick'></i>
              <h3 className='greenGradientTxt'>You’re in control</h3>
              <p>Own your assets & manage your game play experience.</p>
            </div>
            <div className='col-6 threeAnim'>
              <i className='bi bi-lightning-charge'></i>
              <h3 className='greenGradientTxt'>Instant Reward</h3>
              <p>Rewards are credited instantly and verifiably.</p>
            </div>
          </div>
        </section>

        {/* featured in section  */}
        <section className='featuredInSection'>
          <h2 className='section-title greenGradientTxt'>News Hub</h2>
          <div className='Carousel'>
            <Carousel
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={1000}
              centerMode={false}
              className='myTestimonial'
              containerClass='container-with-dots'
              dotListClass='dots'
              draggable={true}
              focusOnSelect={false}
              infinite={true}
              itemClass=''
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={false}
              responsive={responsiveOption}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots={false}
              sliderClass=''
              slidesToSlide={1}
              swipeable={true}
            >
              {articles.map((item, index) => (
                <div style={{ padding: 10 }} key={index}>
                  <div className='featured-box'>
                    <div
                      className='image-section'
                      style={{ backgroundImage: `url(${item.imgLink})` }}
                    ></div>
                    <div className='text-section'>
                      <h4>{item.title}</h4>
                      <div className='publishSection'>
                        <p>{item.publisher}</p>
                        <p>{item.date}</p>
                      </div>
                      <a
                        href={item.url}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Read more
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </section>

        <section>
          <div className='support-main-section header-container'>
            <h2 className='section-title greenGradientTxt'>Backed by</h2>
            <div className='support-image-area'>
              <div className='slide-track'>
                {/* Repeat twice for seamless scrolling */}
                {[...Array(2)].map((_, i) => (
                  <React.Fragment key={i}>
                    <div className='slide'>
                      <Link to='https://www.seiercapital.com/' target='_blank'>
                        <img src={seierLogo} alt='Seier Capital Logo' />
                      </Link>
                    </div>
                    <div className='slide'>
                      <Link to='https://www.concordium.com/' target='_blank'>
                        <img src={concordiumLogo} alt='Concordium Logo' />
                      </Link>
                    </div>
                    <div className='slide'>
                      <Link to='https://www.xvc.tech/' target='_blank'>
                        <img src={XvcLogo} alt='XVC Tech Logo' />
                      </Link>
                    </div>
                    <div className='slide'>
                      <Link to='https://xdc.org/' target='_blank'>
                        <img src={XdcLogo} alt='XDC Logo' />
                      </Link>
                    </div>
                    <div className='slide'>
                      <Link to='https://foundershiphq.com/' target='_blank'>
                        <img src={FoundershipLogo} alt='Foundership HQ Logo' />
                      </Link>
                    </div>
                    <div className='slide'>
                      <Link to='https://www.starknet.io/' target='_blank'>
                        <img src={StarknetLogo} alt='Starknet Logo' />
                      </Link>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className='fantacy-sport-section header-container'>
            <h2 className='text-white'>
              The next generation of
              <span className='greenGradientTxt'> fantasy sports</span>
            </h2>
            <div
              className='fantacy-sport-btn bouncingAnim'
              style={{ marginTop: 100 }}
            >
              <Link
                to='/sign-in'
                state={{ from: location.pathname + location.search }}
              >
                <button className='btn'>Join the FC!</button>
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <Footer />
      </main>
    </>
  )
}
